import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const HelpOutlineIcon = forwardRef<SVGSVGElement, IconProps>(function HelpOutlineIcon(
  { color = '', height = 12, width = 12, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <g clipPath="url(#clip0_102_7260)">
        <path
          d="M6.06 9.495C6.22 9.495 6.355 9.44 6.465 9.33C6.575 9.22 6.63 9.085 6.63 8.925C6.63 8.765 6.575 8.63 6.465 8.52C6.355 8.41 6.22 8.355 6.06 8.355C5.9 8.355 5.765 8.41 5.655 8.52C5.545 8.63 5.49 8.765 5.49 8.925C5.49 9.085 5.545 9.22 5.655 9.33C5.765 9.44 5.9 9.495 6.06 9.495ZM5.56609 6.864C5.52906 7.10556 5.73311 7.305 5.9775 7.305V7.305C6.22189 7.305 6.41456 7.10544 6.45459 6.86435C6.47025 6.77005 6.49122 6.67944 6.5175 6.5925C6.5825 6.3775 6.785 6.13 7.125 5.85C7.435 5.59 7.655 5.335 7.785 5.085C7.915 4.835 7.98 4.56 7.98 4.26C7.98 3.73 7.8075 3.305 7.4625 2.985C7.1175 2.665 6.66 2.505 6.09 2.505C5.6 2.505 5.1675 2.6275 4.7925 2.8725C4.53737 3.03918 4.32969 3.24868 4.16944 3.501C4.04241 3.70103 4.15659 3.95352 4.37829 4.03719V4.03719C4.59548 4.11914 4.83175 4.00492 4.97083 3.81906C5.05453 3.70722 5.15258 3.6117 5.265 3.5325C5.485 3.3775 5.745 3.3 6.045 3.3C6.385 3.3 6.66 3.3925 6.87 3.5775C7.08 3.7625 7.185 4 7.185 4.29C7.185 4.51 7.12 4.7175 6.99 4.9125C6.86 5.1075 6.67 5.31 6.42 5.52C6.12 5.78 5.8975 6.0375 5.7525 6.2925C5.66232 6.45109 5.60018 6.64159 5.56609 6.864ZM6 12C5.16 12 4.375 11.8475 3.645 11.5425C2.915 11.2375 2.28 10.815 1.74 10.275C1.2 9.735 0.775 9.1 0.465 8.37C0.155 7.64 0 6.85 0 6C0 5.16 0.155 4.375 0.465 3.645C0.775 2.915 1.2 2.28 1.74 1.74C2.28 1.2 2.915 0.775 3.645 0.465C4.375 0.155 5.16 0 6 0C6.83 0 7.61 0.155 8.34 0.465C9.07 0.775 9.705 1.2 10.245 1.74C10.785 2.28 11.2125 2.915 11.5275 3.645C11.8425 4.375 12 5.16 12 6C12 6.85 11.8425 7.64 11.5275 8.37C11.2125 9.1 10.785 9.735 10.245 10.275C9.705 10.815 9.07 11.2375 8.34 11.5425C7.61 11.8475 6.83 12 6 12ZM6 11.1C7.41 11.1 8.6125 10.6 9.6075 9.6C10.6025 8.6 11.1 7.4 11.1 6C11.1 4.6 10.6025 3.4 9.6075 2.4C8.6125 1.4 7.41 0.9 6 0.9C4.57 0.9 3.3625 1.4 2.3775 2.4C1.3925 3.4 0.9 4.6 0.9 6C0.9 7.4 1.3925 8.6 2.3775 9.6C3.3625 10.6 4.57 11.1 6 11.1Z"
          fill={color || 'currentColor'}
        />
      </g>
      <defs>
        <clipPath id="clip0_102_7260">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </SvgStyled>
  );
});
